import { __decorate } from "tslib";
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { LocationStrategy } from "@angular/common";
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { AuthService } from "../../../services/auth.service";
import { SharedHttp } from "../../../services/http-client.service";
import { WithdrawWalletModalComponent } from "../withdraw-wallet-modal/withdraw-wallet-modal.component";
import { ComponentService } from "../../../services/component.service";
let CheckProtocolModalWalletComponent = class CheckProtocolModalWalletComponent {
    constructor(httpClient, sanitizer, router, location, themeService, auth, compService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.router = router;
        this.location = location;
        this.themeService = themeService;
        this.auth = auth;
        this.compService = compService;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.user = {};
        this.selectedChain = '';
        this.confirmChain = false;
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        this.selectedChain = this.data.selectedChain.chain.name + ' - ' + this.data.selectedChain.chain.description;
    }
    ngAfterViewInit() {
        const parentElement = document.querySelector('.check-protocol-text');
        parentElement.appendChild(this.popOver.nativeElement);
    }
    submit() {
        if (this.confirmChain && this.data.selectedChain) {
            this.success();
            this.close();
        }
    }
    close() {
        this.modal.destroy();
    }
    closeAndGoBack() {
        this.close();
        this.compService.openModal(WithdrawWalletModalComponent, {
            accountData: this.data.accountData,
            walletData: this.data.walletData
        });
    }
};
CheckProtocolModalWalletComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: Router },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: AuthService },
    { type: ComponentService }
];
__decorate([
    ViewChild('popOver')
], CheckProtocolModalWalletComponent.prototype, "popOver", void 0);
CheckProtocolModalWalletComponent = __decorate([
    Component({
        selector: 'app-check-protocol-modal-wallet',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./check-protocol-modal-wallet.component.html")).default,
    })
], CheckProtocolModalWalletComponent);
export { CheckProtocolModalWalletComponent };
